<script>
    import { navigateTo } from 'yrv'
    import { AuthService } from '../../modules/usersApi/auth/auth.service'

    const auth = new AuthService(null, null)

    if (!auth.isValid()) {
        navigateTo('/login')
    }
</script>

{#if auth.isValid()}
    <slot />
{/if}
